export const HotZone = (nodeList) => {

    const container = [...nodeList]
 
    initHotZone(container)


    function initHotZone(container){
        if (container.length) {
            container.forEach( (hotZone) => {
                const toggleButtons = [...hotZone.querySelectorAll('[data-hot-zone-toggle-dialog]')]

                //bind click event
                toggleButtons.forEach((button) => {
                    button.addEventListener('click', (e) => {
                        e.preventDefault()
                        handleToggleClick(button, toggleButtons,hotZone)
                    } )
                })
             
            })
        }
    }

    function handleToggleClick(button, toggleButtons,hotZone ){
        const isExpanded = (button.getAttribute('aria-expanded') === 'true')
        const targetId = button.dataset.hotZoneToggleDialog ?? null
        toggleDialog(targetId)

        toggleButtons.forEach(current => {
            if (current.hasAttribute('aria-expanded')) {
                if (button === current && isExpanded === false ) {
                    //open
                    current.setAttribute('aria-expanded', 'true')
                    hotZone.scrollIntoView({ behavior: "smooth" })
                }else{
                    //close
                    const currentTargetId = current.dataset.hotZoneToggleDialog ?? null
                    toggleDialog(currentTargetId, true)
                    current.setAttribute('aria-expanded', 'false')
                }
            }
        })
    }

   
    function toggleDialog(id, forceClose = false ){
        const dialog = document.getElementById(id)
        
        if (dialog == undefined) {
            return false
        }else if(forceClose == true && ! dialog.open){
            return true
        }
  
        if (dialog.open || forceClose) {
            dialog.classList.remove('open')
            setTimeout(() => {
                dialog.close()
            }, 300);
        }else{
            dialog.classList.add('open')
            dialog.inert = true
            dialog.show()
            dialog.inert = false

            //update scroll shadow after opening the dialog 
            const scrollArea = dialog.querySelector('[data-scroll-shadow]')
            if (scrollArea) {
                scrollArea.dispatchEvent( new Event("updateScrollShadow") )
            }
      
        }
    }


}